/**
 * Demo Mode (Ghost Mode) schemas — Spec Bölüm 7.1.0
 *
 * Kayıtsız, IP başına günlük 1 demo. AI çağrısı YOK (sabit template rapor).
 */
import { z } from 'zod';

export const DemoStartSchema = z.object({}); // body yok
export type DemoStartInput = z.infer<typeof DemoStartSchema>;

export const DemoAnswerSchema = z.object({
  demoSessionId: z.string().min(20),
  questionId: z.string().min(1),
  selectedOption: z.string().min(1).max(10),
});
export type DemoAnswerInput = z.infer<typeof DemoAnswerSchema>;

export const DemoCompleteSchema = z.object({
  demoSessionId: z.string().min(20),
});
export type DemoCompleteInput = z.infer<typeof DemoCompleteSchema>;
